export const LOCAL_TICKET_EVENT = "atendenexi:ticket-event";
export const LOCAL_CONTACT_EVENT = "atendenexi:contact-event";
export const LOCAL_TICKETS_REFRESH_EVENT = "atendenexi:tickets-refresh";

export const emitLocalTicketEvent = detail => {
  if (typeof window === "undefined" || !detail) return;

  window.dispatchEvent(new CustomEvent(LOCAL_TICKET_EVENT, { detail }));
};

export const emitLocalTicketsRefresh = detail => {
  if (typeof window === "undefined") return;

  window.dispatchEvent(new CustomEvent(LOCAL_TICKETS_REFRESH_EVENT, { detail }));
};

export const emitLocalContactEvent = detail => {
  if (typeof window === "undefined" || !detail) return;

  window.dispatchEvent(new CustomEvent(LOCAL_CONTACT_EVENT, { detail }));
};

export const notifyTicketMutation = response => {
  if (typeof window === "undefined" || !response?.config) return;

  const method = String(response.config.method || "").toLowerCase();
  const url = String(response.config.url || "");
  const ticketMatch = url.match(/\/tickets\/(\d+)/);
  const messageMatch = url.match(/\/messages\/([^/?]+)/);
  const messageTemplateMatch = url.match(/\/messages-template\/([^/?]+)/);
  const messageEditMatch = url.match(/\/messages\/edit\/([^/?]+)/);

  if (method === "post" && url === "/tags/sync" && response.data?.id) {
    emitLocalContactEvent({ action: "update", contact: response.data });
    emitLocalTicketsRefresh({ reason: "contact-tags-updated", contactId: response.data.id });
    return;
  }

  if (method === "post" && url === "/tickets" && response.data?.id) {
    emitLocalTicketEvent({ action: "update", ticket: response.data });
    emitLocalTicketsRefresh({ reason: "ticket-created", ticketId: response.data.id });
    return;
  }

  if (ticketMatch && ["put", "patch"].includes(method)) {
    if (response.data?.id) {
      emitLocalTicketEvent({ action: "update", ticket: response.data });
      emitLocalTicketsRefresh({ reason: "ticket-updated", ticketId: response.data.id });
    } else {
      emitLocalTicketsRefresh({ reason: "ticket-updated", ticketId: Number(ticketMatch[1]) });
    }
    return;
  }

  if (ticketMatch && method === "delete") {
    emitLocalTicketEvent({ action: "delete", ticketId: Number(ticketMatch[1]) });
    emitLocalTicketsRefresh({ reason: "ticket-deleted", ticketId: Number(ticketMatch[1]) });
    return;
  }

  if (messageMatch && method === "post") {
    emitLocalTicketsRefresh({ reason: "message-created", ticketId: messageMatch[1] });
    return;
  }

  if (messageTemplateMatch && method === "post") {
    emitLocalTicketsRefresh({ reason: "message-created", ticketId: messageTemplateMatch[1] });
    return;
  }

  if (messageEditMatch && method === "post") {
    emitLocalTicketsRefresh({ reason: "message-updated", messageId: messageEditMatch[1] });
  }
};
